import { bootstrapTerminHTMLsOnWindowLoad } from "./bootstrap";

bootstrapTerminHTMLsOnWindowLoad();
